import React, { useState } from "react";
import iconSprite from "bootstrap-italia/dist/svg/sprite.svg";
import "./AlertMessage.css";

function AlertMessage({ isVisible, onClose, error }) {
  const [errorMessage, setErrorMessage] = useState("");

  const handleClose = () => {
    if (onClose) {
      onClose();
    }
  };

  return (
    isVisible && (
      <div
        className="alert alert-danger alert-dismissible fade show"
        role="alert"
      >
        <strong>Attenzione</strong> {error}
        <button
          type="button"
          className="btn-close"
          data-bs-dismiss="alert"
          aria-label="Chiudi avviso"
          onClick={handleClose}
        >
          <svg className="icon">
            <use xlinkHref={`${iconSprite}#it-close`}></use>
          </svg>
        </button>
      </div>
    )
  );
}

function showError(error) {
  const MESSAGE_ERROR_DEFAULT =
    "Oops qualcosa è andato storto. Riprova più tardi!";
  console.log(error);
  return (
    error.response?.data?.Message ||
    error.response?.data ||
    MESSAGE_ERROR_DEFAULT
  );
}

export { AlertMessage, showError };
export default AlertMessage;
